export enum PlatformType {
    Android = 'Android',
    iOS = 'iOS',
    Browser = 'Browser',
    PWA = 'PWA'
}
